export default [
  {
    path: '/activity-20250909-main',
    component: () => import('./Page.vue'),
    meta: { title: 'PK赛榜单' },
  },
  {
    path: '/activity-20250909-test',
    component: () => import('./test.vue'),
    meta: { title: '甜蜜约会-规则说明' },
  },
]
